export default __webpack_public_path__ + "static/media/ico_wear_gray.8c1647cb.svg";